import React, { useEffect, useState } from 'react'
import { classementAPI, domain, getCorrectListClub, getLongNameChamp, listClubProad } from '../variables';
import './PlayOffDown.css';
import Tabulation from '../components/Playoffs/Tabulation';
import ContainerMatch from '../components/Playoffs/ContainerMatch';

import axios from "axios";
import logoProAM from '../assets/proam.png'
import logoProBM from '../assets/probm.png'
import logoProAD from '../assets/proad.png'
import logoProBD from '../assets/probd.png'

const PlayOffDown = ({championnat}) => {
    const [classement, setClassement] = useState(null);
    const [playoffsMatchs, setPlayoffsMatchs] = useState(null);
    const [playdownMatchs, setPlaydownMatchs] = useState(null);
    const [tabulationActive, setTabulationActive] = useState(1);

    const updatePage = () => {
        setPlayoffsMatchs(null);
        setPlaydownMatchs(null);
        setClassement(null);
        setTabulationActive(1);
        // A chaque changement de division on récupère le classement et les matchs de la division concernée
        getClassement();
        getPlayoffsMatchs();
        getPlaydownMatchs();
    }

    useEffect(() => {
        updatePage()
    }, []);

    useEffect(() => {
        updatePage()
    }, [championnat]);

    useEffect(() => { 
        if (classement) {
            if (tabulationActive === 1 && !playoffsMatchs) {
                getPlaydownMatchs();
            }
            if (tabulationActive === 2 && !playdownMatchs) {
                getPlaydownMatchs();
            }
        }
    }, [tabulationActive])

    // fonction pour récupérer le classement
    const getClassement = async () => {
        const url = classementAPI.find(link => link.for === championnat)?.link;
        if (url) {
            axios
            .get(url, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                setClassement(res.data);
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    }

    // Fonction pour récupérer les matchs de playoffs
    const getPlayoffsMatchs = async () => {
        // on construit l'URL
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                offOrDown: "off",
                withSets: true
            })

            if (response) {
                parseMatchs(response.data, "off");
            }
        } 
        catch (error) {
            console.log(error);
        }
    }

    // Fonction pour récupérer les matchs de playoffs
    const getPlaydownMatchs = async () => {
        // on construit l'URL
        const url = `${domain}/server/getPODMatchs.php`;
        try {
            const response = await axios.post(url, {
                division: championnat,
                offOrDown: "down",
                withSets: true
            })

            if (response) {
                parseMatchs(response.data, "down");
            }
        } 
        catch (error) {
            console.log(error);
        }
    }

    // Fonction pour regrouper les matchs ensemble car on récupère plusieurs lignes pour un même match selon le nombre de partie joués
    const parseMatchs = (matchs, offOrDown) => {
        let parsedMatchs = [];
        // on veut regrouper les mêmes matchs en y ajoutant les sets joués dans un seul objet
        matchs.forEach((match) => {
            const indexMatch = parsedMatchs.findIndex(p => p.renc_id === match.renc_id);
            if (indexMatch > -1) {
                // si on trouve le match et que des sets sont joués alors on rajoute uniquement les sets
                if (match.sets_data) {
                    parsedMatchs[indexMatch].sets_data.push(match.sets_data);
                }
            }
            else {
                // si on a pas déjà trouvé le match alors on le push dans le tableau
                parsedMatchs.push({
                    ...match,
                    sets_data: [match.sets_data]
                })
            }
        });
        if (offOrDown === "off") {
            setPlayoffsMatchs(parsedMatchs)
        }
        if (offOrDown === "down") {
            setPlaydownMatchs(parsedMatchs)
        }
    }

    // Fonction pour récupérer un club en fonction de sa place dans le classement
    const getClubByRanking = (place) => {
        // s'il y a un classement
        if (classement) {
            // on récupère l'id du club à la place x
            const identifierClub = infoClassement(place-1, 'numero'); 
            // on récupère le nom du club
            const nameClub = infoClassement(place-1, "equipe")?.trim();

            // on récupère le club dans la bonne liste de division
            const club = getCorrectListClub(championnat).find(club => (club.identifier === identifierClub) || (club.title.trim() === nameClub)); 

            // on ajoute le classement à notre objet
            const clubWithRanking = {
                ...club,
                ["ranking"]: place
            }
            
            // on retourne le club
            return clubWithRanking;
        }

        // sinon null
        return null;
    }

    // Fonction pour récupérer le ranking d'un club
    const getRankingByClub = (club) => {
        if (classement) {
            let ranking = 0;
            classement.forEach((c) => {
                const name = c.equipe?.replace(/ +(?= )/g,'').trim();
                if (name === club?.title?.trim()) {
                    ranking = c.clt?.trim();
                }
            });
            return ranking;
        }
        return null;
    }

    const determineWinnerByMatch = (matchsA, matchsB) => {
        if(matchsA == matchsB) { return "equal"; }
        return matchsA > matchsB ? "home" : "away";
    }

    // Fonction pour calculer le nombre de manche gagné au total dans une rencontre
    // utilisé en cas d'égalité pour pouvoir départager les deux équipes
    const determineWinnerByRounds = (setsAller, setsRetour) => {
        let homeRoundWon = 0;
        let awayRoundWon = 0;
        if (setsAller && setsRetour) {
            setsAller.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // set est un string
                    // Format d'un set exemple : -09 07 -10 -09
                    // lorsqu'il y a un - l'équipe à domicile perd le set
                    if (point[0] !== "-") {
                        homeRoundWon++; // si il n'y a pas de - alors le set est gagné
                    }
                    else {
                        awayRoundWon++; // s'il y a un - l'équipe extérieur gagne le set
                    }
                })
            });
            setsRetour.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // ici les équipes sont inversées puisque le domicile passe à l'extérieur
                    if (point[0] !== "-") {
                        awayRoundWon++; 
                    }
                    else {
                        homeRoundWon++;
                    }
                })
            });
            if (homeRoundWon === awayRoundWon) return "equal";
            return homeRoundWon > awayRoundWon ? "home" : "away";
        }
        return null;
    }

    // Fonction pour calculer le nombre de points gagnés au total dans une rencontre
    // utilisé en cas d'égalité pour pouvoir départager les deux équipes
    const determineWinnerByTotalPoints = (setsAller, setsRetour) => {
        let homePointsWon = 0;
        let awayPointsWon = 0;
        if (setsAller && setsRetour) {
            setsAller.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // set est un string
                    // Format d'un set exemple : -09 07 -10 -09
                    // lorsqu'il y a un - l'équipe à domicile perd le set
                    if (point[0] !== "-") {
                        homePointsWon += parseInt(point) >= 10 ? parseInt(point) + 2 : 11;
                        awayPointsWon += parseInt(point);
                    }
                    else {
                        const set = point.substring(1); // on retire le -
                        awayPointsWon += parseInt(set) >= 10 ? parseInt(set) + 2 : 11; 
                        homePointsWon += parseInt(set);
                    }
                })
            });
            setsRetour.forEach((sets) => {
                sets?.split(" ").forEach((point) => {
                    // ici les équipes sont inversées puisque le domicile passe à l'extérieur
                    if (point[0] !== "-") {
                        awayPointsWon += parseInt(point) >= 10 ? parseInt(point) + 2 : 11; 
                        homePointsWon += parseInt(point);
                    }
                    else {
                        const set = point.substring(1); // on retire le -
                        homePointsWon += parseInt(set) >= 10 ? parseInt(set) + 2 : 11; 
                        awayPointsWon += parseInt(set);
                    }
                })
            });
            if (homePointsWon === awayPointsWon) return "equal";
            return homePointsWon > awayPointsWon ? "home" : "away";
        }
        return null;
    }


    // Fonction pour récupérer le bon match
    const getRightMatch = (clubTop, clubBot, isRetour = false) => {
        const matchs = tabulationActive === 1 ? playoffsMatchs : playdownMatchs;
        if (matchs && clubTop && clubBot) {
            const dayMatchAller = [16, 18, 20]; const dayMatchRetour = [17, 19, 21];
            const match = matchs.find((match) => {
                const day = parseInt(match.day_id);
                const nameDom = match.domicile?.replace(/ +(?= )/g,'').trim(); // on enlève les doubles espace / AMIENS STT  1 par exemple contient deux espaces
                const nameExt = match.exterieur?.replace(/ +(?= )/g,'').trim();
                //
                if (!isRetour) {
                    return dayMatchAller.includes(day) 
                    && 
                    (nameDom === clubTop.title?.trim() || nameDom === clubBot.title?.trim())
                    &&
                    (nameExt === clubTop.title?.trim() || nameExt === clubBot.title?.trim())
                }
                else {
                    return dayMatchRetour.includes(day) 
                    && 
                    (nameDom === clubTop.title?.trim() || nameDom === clubBot.title?.trim())
                    &&
                    (nameExt === clubTop.title?.trim() || nameExt === clubBot.title?.trim())
                }
            });
            return match;
        }
        return null;
    }

    // fonction pour récupérer le gagnant d'un match grâce au classement des clubs
    const getWinnerOfMatch = (homeRanking, awayRanking, getPlace = false) => {
        if (homeRanking === null || awayRanking === null || homeRanking === undefined || awayRanking === undefined) return null;
        // on récupère les clubs avec le classement
        const homeClub = getClubByRanking(homeRanking);
        const awayClub = getClubByRanking(awayRanking);
        // on récupère les matchs
        const matchs = tabulationActive === 1 ? playoffsMatchs : playdownMatchs;
        // si on a les matchs
        if (matchs) {
            // on recherche le bon match
            // const match = matchs.find((match) => match?.domicile?.trim() === homeClub?.title?.trim() && match?.exterieur?.trim() === awayClub?.title?.trim());
            const match = getRightMatch(homeClub, awayClub, false)
            if (match && match?.winner !== null) {
                // const matchRetour = matchs.find((match) => match.domicile.trim() === awayClub?.title.trim() && match.exterieur.trim() === homeClub?.title.trim());
                const matchRetour = getRightMatch(homeClub, awayClub, true);
                if (matchRetour && matchRetour?.winner !== null) {
                    const winnerAller = match.winner;
                    const winnerRetour = matchRetour.winner;
                    // On regarde si on a le même gagnant pour les deux matchs
                    // la team à domicile passe à l'extérieur au match retour
                    if (winnerAller === "home" && winnerRetour === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // la team extérieur passe à domicile au retour
                    if (winnerAller === "away" && winnerRetour === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité on veut départager les équipes avec le nombre de partie gagné
                    const partiesA = parseInt(match.home_points) + parseInt(matchRetour.away_points);
                    const partiesB = parseInt(match.away_points) + parseInt(matchRetour.home_points);                  
                    const winnerByTotalMatchs = determineWinnerByMatch(partiesA, partiesB);
                    if (winnerByTotalMatchs === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByTotalMatchs === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité on veut départager les équipes avec le nombre de manche gagné
                    // on commence par récupérer les sets              
                    const setsAller = match.sets_data;
                    const setsRetour = matchRetour.sets_data;
                    // puis on calcule les manches gagnées
                    const winnerByRounds = determineWinnerByRounds(setsAller, setsRetour);
                    if (winnerByRounds === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByRounds === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité au nombre de manche gagné alors on départage avec les points
                    const winnerByTotalPoints = determineWinnerByTotalPoints(setsAller, setsRetour);
                    if (winnerByTotalPoints === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByTotalPoints === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    console.log("Egalité score final, manches et points totals")
                }
            }
        }
        return null;
    }

    // fonction pour récupérer le perdant d'un match grâce au classement des clubs
    const getLooserOfMatch = (homeRanking, awayRanking, getPlace = false) => {
        if (homeRanking === null || awayRanking === null || homeRanking === undefined || awayRanking === undefined) return null;
        // on récupère les clubs avec le classement
        const homeClub = getClubByRanking(homeRanking);
        const awayClub = getClubByRanking(awayRanking);
        // on récupère les matchs
        const matchs = tabulationActive === 1 ? playoffsMatchs : playdownMatchs;
        // si on a les matchs
        if (matchs) {
            // on recherche le bon match
            // const match = matchs.find((match) => match?.domicile?.trim() === homeClub?.title?.trim() && match?.exterieur?.trim() === awayClub?.title?.trim());
            const match = getRightMatch(homeClub, awayClub, false)
            if (match && match?.winner !== null) {
                // const matchRetour = matchs.find((match) => match.domicile.trim() === awayClub?.title.trim() && match.exterieur.trim() === homeClub?.title.trim());
                const matchRetour = getRightMatch(homeClub, awayClub, true);
                if (matchRetour && matchRetour?.winner !== null) {
                    const winnerAller = match.winner;
                    const winnerRetour = matchRetour.winner;
                    // On regarde si on a le même gagnant pour les deux matchs
                    // la team à domicile passe à l'extérieur au match retour
                    if (winnerAller === "home" && winnerRetour === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // la team extérieur passe à domicile au retour
                    if (winnerAller === "away" && winnerRetour === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité on veut départager les équipes avec le nombre de partie gagné
                    const partiesA = parseInt(match.home_points) + parseInt(matchRetour.away_points);
                    const partiesB = parseInt(match.away_points) + parseInt(matchRetour.home_points); 
                    const winnerByTotalMatchs = determineWinnerByMatch(partiesA, partiesB);
                    if (winnerByTotalMatchs === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByTotalMatchs === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité on veut départager les équipes avec le nombre de manche gagné
                    // on commence par récupérer les sets
                    const setsAller = match.sets_data;
                    const setsRetour = matchRetour.sets_data;
                    // puis on calcule les manches gagnées
                    const winnerByRounds = determineWinnerByRounds(setsAller, setsRetour);
                    if (winnerByRounds === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByRounds === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    // en cas d'égalité au nombre de manche gagné alors on départage avec les points
                    const winnerByTotalPoints = determineWinnerByTotalPoints(setsAller, setsRetour);
                    if (winnerByTotalPoints === "home") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.exterieur?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    if (winnerByTotalPoints === "away") {
                        let rightClub = getCorrectListClub(championnat).find(c => c.title.trim() === match.domicile?.replace(/ +(?= )/g,'').trim());
                        rightClub = {...rightClub, ranking: getRankingByClub(rightClub)};
                        if (getPlace) return rightClub?.ranking; // getPlace = true, on veut récupérer uniquement le classement et pas le club
                        return rightClub;
                    }
                    console.log("Egalité score final, manches et points totals")
                }
            }
        }
        return null;
    }

    const getEncounter = (homeClub, awayClub) => {
        const match = getRightMatch(homeClub, awayClub);
        const matchRetour = getRightMatch(homeClub, awayClub, true);
        return [
            match,
            matchRetour
        ];
    }

    const infoClassement = (index, value) => {
        if (classement) {
            return classement[index]?.[value];
        }
        return null;
    }

    return ( 
        <div className='playoffdown_page'>
            {/* // BANNIERE */}
            <div className={"top_banniere " + championnat}>
                {
                    championnat == 'proam' &&
                        <span>
                            <img src={logoProAM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'proad' &&
                        <span>
                            <img src={logoProAD} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probm' &&
                        <span>
                            <img src={logoProBM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probd' &&
                        <span>
                            <img src={logoProBD} alt="Logo pro" className="logo_p" />
                        </span>
                }               
                <span className="top_banniere_title">          
                    Playoffs {getLongNameChamp(championnat)}
                </span>
            </div>
            <div className='playoffdown_content'>
                <div className='playoffdown_tabulation'>
                    <Tabulation 
                        title="Playoffs"
                        onClick={() => setTabulationActive(1)}
                        active={tabulationActive === 1}
                    />
                    <Tabulation 
                        title="Playdowns"
                        onClick={() => setTabulationActive(2)}
                        active={tabulationActive === 2}
                    />
                </div>

                <div className='playoffdown_matchs'>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: 'fit-content', 
                    }}>
                        {/* MATCHS */}
                        <div style={{display: 'flex' , flexDirection: 'column', gap: 50}}>
                            <div style={{display: 'flex'}}>
                                <ContainerMatch 
                                    clubTop={tabulationActive === 1 ? getClubByRanking(5) : getClubByRanking(11)}
                                    clubBot={tabulationActive === 1 ? getClubByRanking(4) : getClubByRanking(10)}
                                    getEncounter={getEncounter}
                                    style={{
                                        paddingTop: 80
                                    }}
                                    championnat={championnat}
                                    lineWidth={'100%'} 
                                />
                                <ContainerMatch
                                    clubTop={tabulationActive === 1 ? getClubByRanking(1) : getClubByRanking(7)}
                                    clubBot={tabulationActive === 1 ? getWinnerOfMatch(5,4) : getWinnerOfMatch(11,10)}
                                    getEncounter={getEncounter}
                                    championnat={championnat} 
                                    lineHeight={20}
                                    lineWidth={270} 
                                />
                            </div>
                            <div style={{display: 'flex'}}>
                                <ContainerMatch 
                                    clubTop={tabulationActive === 1 ? getClubByRanking(3) : getClubByRanking(9)}
                                    clubBot={tabulationActive === 1 ? getClubByRanking(6) : getClubByRanking(12)}
                                    getEncounter={getEncounter}
                                    style={{
                                        paddingBottom: 80
                                    }}
                                    championnat={championnat}
                                    lineWidth={'100%'}  
                                />
                                <ContainerMatch
                                    clubTop={tabulationActive === 1 ? getWinnerOfMatch(3,6) : getWinnerOfMatch(9,12)}
                                    clubBot={tabulationActive === 1 ? getClubByRanking(2) : getClubByRanking(8)}
                                    getEncounter={getEncounter}
                                    championnat={championnat} 
                                    lineHeight={20} 
                                    lineWidth={270} 
                                />
                            </div>
                        </div>
                        {/* SEPARATEUR FINALE  */}
                        <div 
                            style={{
                                height: '55.6%',
                                width: 4,
                                backgroundColor: 'black'
                            }}
                        />
                        {/* FINALE */}
                        <ContainerMatch
                            clubTop={tabulationActive === 1 ? getWinnerOfMatch(1, getWinnerOfMatch(5, 4, true)) : getWinnerOfMatch(7, getWinnerOfMatch(11, 10, true))}
                            clubBot={tabulationActive === 1 ? getWinnerOfMatch(getWinnerOfMatch(3, 6, true), 2) : getWinnerOfMatch(getWinnerOfMatch(9, 12, true), 8)}
                            getEncounter={getEncounter}
                            getWinner={getWinnerOfMatch}
                            invertedLine 
                            lineWidth={183}
                            championnat={championnat}
                            isFinal 
                        />
                    </div>
                        
                </div>


                <div style={{
                    padding: '0 50px 0',
                }}>
                    <h3>{tabulationActive === 1 ? "Places 3 - 4" : "Places 9 - 10"}</h3>
                </div>
                <div className='playoffdown_matchs' style={{
                    padding: '0 50px 50px',
                }}>
                    <ContainerMatch
                    clubTop={championnat === 'probm'
                        ? tabulationActive === 1 ? getLooserOfMatch(1, getWinnerOfMatch(5, 4, true)) : getLooserOfMatch(7, getWinnerOfMatch(11, 10, true))
                        : tabulationActive === 1 ? getLooserOfMatch(1, getWinnerOfMatch(5, 4, true)) : getLooserOfMatch(7, getWinnerOfMatch(11, 10, true))
                    }
                    clubBot={championnat === 'probm'
                        ? tabulationActive === 1 ? getLooserOfMatch(getWinnerOfMatch(3, 6, true), 2) : getLooserOfMatch(getWinnerOfMatch(9, 12, true), 8)
                        : tabulationActive === 1 ? getLooserOfMatch(getWinnerOfMatch(3, 6, true), 2) : getLooserOfMatch(getWinnerOfMatch(9, 12, true), 8)
                    }
                    getEncounter={getEncounter} getWinner={getWinnerOfMatch} invertedLine={false} lineWidth={0}
                    championnat={championnat} isFinal={true}/>
                </div>

                <div style={{
                    padding: '0 50px 0',
                }}>
                    <h3>{tabulationActive === 1 ? "Places 5 - 6" : "Places 11 - 12"}</h3>
                </div>
                <div className='playoffdown_matchs' style={{
                    padding: '0 50px',
                }}>
                    <ContainerMatch
                    clubTop={championnat === 'probm'
                        ? tabulationActive === 1 ? getLooserOfMatch(4,5) : getLooserOfMatch(10,11)
                        : tabulationActive === 1 ? getLooserOfMatch(4,5) : getLooserOfMatch(10,11)
                    }
                    clubBot={championnat === 'probm'
                        ? tabulationActive === 1 ? getLooserOfMatch(3,6) : getLooserOfMatch(9,12)
                        : tabulationActive === 1 ? getLooserOfMatch(3,6) : getLooserOfMatch(9,12)
                    }
                    getEncounter={getEncounter} getWinner={getWinnerOfMatch} invertedLine={false} lineWidth={0}
                    championnat={championnat} isFinal={true}/>
                </div>
            </div>
        </div>
     );
}
 
export default PlayOffDown;